import { createSelector } from '@reduxjs/toolkit';

import { type PartnerTaskDto } from '@/common/types/query/tasks';

import { type RootState } from '../store';

import { checkPartnerTaskTimer } from './lib';

const selectPartnersTask = (state: RootState): PartnerTaskDto[] => {
  const allPartners = [
    ...(state.tasks.partners || []),
    ...(state.tasks.social || []),
  ];

  return allPartners.flatMap((partner) => partner.partnerTask);
};

const selectHasPendingPartnerTasks = createSelector(
  [selectPartnersTask],
  (partnerTasks) => {
    if (!partnerTasks || partnerTasks.length === 0) {
      return false;
    }

    return partnerTasks.some(
      (partnerTask) =>
        partnerTask?.status === null || partnerTask?.status === 'pending',
    );
  },
);

const partnersTaskTimerEnd = createSelector(
  selectPartnersTask,
  checkPartnerTaskTimer,
);

export { partnersTaskTimerEnd, selectHasPendingPartnerTasks };
